import { makeToastQueue } from '@synoptic/ui-kit/toast/toast-queue.js';

export const toastQueue = makeToastQueue();
